import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Chess from './pages/Chess';
import Coaches from './pages/Coaches';
import DanceCoach from './pages/DanceCoach';
import Programs from './pages/Programs';
import Testimonials from './pages/Testimonials';
import Contact from './pages/Contact';
import Dance from './pages/Dance';

import Blog from './pages/Blog';
import Login from './pages/Login';
import Booking from './pages/Booking';

function App() {
  return (
    <Router>
      <div className="d-flex flex-column min-vh-100">
        <Navbar />
        <main className="flex-grow-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/chess" element={<Chess />} />
            <Route path="/coaches" element={<Coaches />} />
            <Route path="/coaches/dance" element={<DanceCoach />} />
            <Route path="/programs" element={<Programs />} />
            <Route path="/testimonials" element={<Testimonials />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/login" element={<Login />} />
            <Route path="/book/:serviceId" element={<Booking />} />
            <Route path="/dance" element={<Dance />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;